import { SiloConfiguration } from '@silo/config-legacy';
import { Web3Context } from '../web3Context';
import { BigNumberFromString, ChecksumAddress, LendingMerklRewardLegacy } from '@silo/types';
import * as t from 'io-ts';
import { BigIntFromString } from 'io-ts-types';
import { MerklCampaign } from '@silo/data';

export const SiloAsset = t.type({
  assetAddress: ChecksumAddress,
  assetKey: t.union([t.literal('base'), t.literal('firstBridge'), t.literal('secondBridge')]),
  totalDeposits: BigNumberFromString,
  collateralOnlyDeposits: BigNumberFromString,
  totalBorrowAmount: BigNumberFromString,
  liquidity: BigNumberFromString,
  utilization: BigNumberFromString,
  symbol: t.string,
  rawSymbol: t.string,
  name: t.string,
  decimals: t.number,
  isNative: t.boolean,
  isPaused: t.boolean,
  depositAPY: BigNumberFromString,
  collateralRewardsApr: BigNumberFromString,
  protectedRewardsApr: BigNumberFromString,
  depositRewardsApr: BigNumberFromString,
  borrowAPY: BigNumberFromString,
  borrowRewardsApr: BigNumberFromString,
  /**
   * Token used to grab the user balance - not necessarily the silo asset address (for example, Curve LP deposits)
   */
  userBalanceTokenAddress: ChecksumAddress,
  userBalance: BigNumberFromString,
  collateralBalance: BigNumberFromString,
  collateralOnlyBalance: BigNumberFromString,
  debtBalance: BigNumberFromString,
  projectedDebtBalance: BigNumberFromString,
  priceInNative: BigNumberFromString,
  priceProviders: ChecksumAddress,
  maximumLTV: BigNumberFromString,
  liquidationThreshold: BigNumberFromString,
  isCurveLpAsset: t.boolean,
  lendingMerklRewards: t.array(LendingMerklRewardLegacy),

  collateralTotal: BigIntFromString,
  collateralEmissionPerSecond: BigIntFromString,
  protectedTotal: BigIntFromString,
  protectedEmissionPerSecond: BigIntFromString,
  debtTotal: BigIntFromString,
  debtEmissionPerSecond: BigIntFromString,
  rewardTokenPriceUsd: BigIntFromString,
  rewardTokenDecimals: t.number,
  tokenPriceUsd: BigIntFromString,
});
export type SiloAsset = t.TypeOf<typeof SiloAsset>;

export const DecoratedSilo = t.type({
  siloAddress: ChecksumAddress,
  assets: t.array(SiloAsset),
  userLTV: BigNumberFromString,
  userLiquidationThreshold: BigNumberFromString,
  userMaximumLTV: BigNumberFromString,
  hasPosition: t.boolean,
  routerAddress: ChecksumAddress,
});
export type DecoratedSilo = t.TypeOf<typeof DecoratedSilo>;

/**
 * @deprecated use granular queries instead
 */
export const decoratedSiloKey = 'decoratedSilo';

export type DecoratedSiloKey = [
  key: typeof decoratedSiloKey,
  web3Context: Web3Context,
  siloAddress: ChecksumAddress,
  siloConfig: SiloConfiguration,
  merklCampaigns: MerklCampaign[]
];
